__turbopack_context__.v({
  "product-card": "ProductCard-module-scss-module__DmhGrG__product-card",
  "product-card__separator": "ProductCard-module-scss-module__DmhGrG__product-card__separator",
  "product-card__separator--bottom": "ProductCard-module-scss-module__DmhGrG__product-card__separator--bottom",
});
